export const templateTypeOptions = [
  {
    label: 'Introduction',
    value: 'Introduction',
  },
  {
    label: 'Conclusion',
    value: 'Ending',
  },
  {
    label: 'Signature',
    value: 'Signature',
  },
  {
    label: 'Contenu',
    value: 'Body',
  },
]
